import { render, staticRenderFns } from "./CampaignCommissionReview.vue?vue&type=template&id=bfc4d948&"
import script from "./CampaignCommissionReview.vue?vue&type=script&lang=js&"
export * from "./CampaignCommissionReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports